import React from 'react';
import { Card, CardContent, Typography, withStyles } from '@material-ui/core';

const styles = (theme) => ({
  agreementContainer: {
    // height: '150px',
    height: 'fit-content',
    overflowY: 'auto',
  },
  body: {
    fontSize: '1.1em',
  },
});

class AgreementDiv extends React.Component {
  render() {
    const { classes, noneHeight } = this.props;
    return (
      <Card className={noneHeight ? 'noneHeight' : classes.agreementContainer} variant="outlined">
        <CardContent>
          <Typography component={'div'} className={classes.body}>
            {this.props.children}
          </Typography>
        </CardContent>
      </Card>
    );
  }
}

export default withStyles(styles, { withTheme: true })(AgreementDiv);
